import { render } from "./EmptyHome.vue?vue&type=template&id=0b76a04d"
import script from "./EmptyHome.vue?vue&type=script&lang=js"
export * from "./EmptyHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__